module.exports = __webpack_public_path__ + "img/jp.b05771a9.png";